import { createTypes } from "../../utils/helpers"

const FETCH_UPLOAD_HISTORY: any = createTypes("FETCH_UPLOAD_HISTORY")
const FETCH_UPLOAD_REPORT: any = createTypes("FETCH_UPLOAD_REPORT")
const DOWNLOAD_EXCEL: any = createTypes("DOWNLOAD_EXCEL")
const UPLOAD_HISTORY_SET_PAGE = 'UPLOAD_HISTORY_SET_PAGE';
const VIEW_REPORT_SET_PAGE = 'VIEW_REPORT_SET_PAGE';
const UPLOAD_HISTORY_SET_ROWS_PER_PAGE = 'UPLOAD_HISTORY_SET_ROWS_PER_PAGE';
const VIEW_REPORT_SET_ROWS_PER_PAGE = 'VIEW_REPORT_SET_ROWS_PER_PAGE';

export {
    FETCH_UPLOAD_HISTORY,
    FETCH_UPLOAD_REPORT,
    DOWNLOAD_EXCEL,
    UPLOAD_HISTORY_SET_PAGE,
    VIEW_REPORT_SET_PAGE,
    UPLOAD_HISTORY_SET_ROWS_PER_PAGE,
    VIEW_REPORT_SET_ROWS_PER_PAGE
}